var React = require('react');

function PromosIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.666 10c0-.917.75-1.667 1.667-1.667V5c0-.917-.75-1.667-1.666-1.667H3.332c-.917 0-1.658.75-1.658 1.667v3.333c.916 0 1.658.75 1.658 1.667s-.742 1.667-1.667 1.667V15c0 .917.75 1.667 1.667 1.667h13.334c.916 0 1.666-.75 1.666-1.667v-3.333c-.916 0-1.666-.75-1.666-1.667zm-3.683 4L10 12.083 7.016 14l.9-3.433-2.741-2.242 3.533-.208L10 4.833l1.283 3.292 3.534.208-2.742 2.242.908 3.425z","fill":"#fff"}));
}

PromosIcon.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = PromosIcon;

PromosIcon.default = PromosIcon;
